const o=(r=0,(o="")=>`${o}${++r}`);var r;export{o as uniqueId};
